import { useState } from 'react';
import { Autocomplete, Box, Button, Chip, CircularProgress, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { watchlistService } from '../../../application/services/watchlist-service';

export default function SymbolSelectWithWatchButton({ watchedSymbols, onWatch, onUnwatch, busy }) {
  const [selected, setSelected] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [side, setSide] = useState('LONG');
  const isWatched = watchedSymbols.has(selected);
  const isValidSelection = options.includes(selected) && inputValue === selected;

  const fetchSymbols = async (query) => {
    setLoading(true);
    try {
      const results = await watchlistService.search(query);
      setOptions(results.map((item) => item.symbol));
    } catch {
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (_event, value) => {
    setInputValue(value);
    if (value && value.length >= 2) {
      fetchSymbols(value);
    } else {
      setOptions([]);
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
      <Autocomplete
        sx={{ minWidth: 280, flex: '1 1 360px' }}
        freeSolo
        options={options}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        value={selected}
        onChange={(_event, value) => {
          const next = value ? String(value).toUpperCase() : '';
          setSelected(next);
          setInputValue(next);
        }}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label="Symbol"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>{loading ? <CircularProgress size={18} /> : null}{params.InputProps.endAdornment}</>
              ),
            }}
          />
        )}
      />
      <ToggleButtonGroup
        exclusive
        value={side}
        onChange={(_event, value) => value && setSide(value)}
        size="small"
      >
        <ToggleButton value="LONG" color="success">LONG</ToggleButton>
        <ToggleButton value="SHORT" color="error">SHORT</ToggleButton>
      </ToggleButtonGroup>
      {isWatched ? <Chip color="success" label="Đang theo dõi" /> : null}
      <Button
        variant={isWatched ? 'outlined' : 'contained'}
        color={isWatched ? 'error' : 'primary'}
        disabled={busy || !isValidSelection}
        onClick={() => (isWatched ? onUnwatch(selected) : onWatch(selected, side))}
      >
        {isWatched ? 'Bỏ theo dõi' : 'Theo dõi'}
      </Button>
    </Box>
  );
}
